/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../../styles/sidebar.css";
import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Box,
    Tooltip,
} from '@mui/material';
import {
    ExpandLess,
    ExpandMore,
} from '@mui/icons-material';
import { useAuth } from '../../AuthContext';

interface SidebarProps {
    open: boolean;
    onClose: () => void;
    onToggle?: () => void;
}

const DRAWER_WIDTH = 220;
const COLLAPSED_WIDTH = 64;

type LocalIconProps = {
    src: string;
    alt?: string;
    className?: string;
};

const LocalIcon: React.FC<LocalIconProps> = ({ src, alt = "", className }) => (
    <img
        src={src}
        alt={alt}
        className={className}
        loading="lazy"
    />
);

const Sidebar: React.FC<SidebarProps> = ({ open, onClose, onToggle }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAdmin, isManager } = useAuth();
     const isEmployee = !isAdmin && !isManager;
   //const isAdmin = true;
 //  const isManager = false;
    const [masterOpen, setMasterOpen] = useState(
        location.pathname === '/categories' ||
        location.pathname === '/technologies'
    );

    const [selectedPath, setSelectedPath] = React.useState<string>(location.pathname);

    const handleNavigate = (path: string) => {
        setSelectedPath(path);
        navigate(path);
    };

    const isSelected = (path: string) => selectedPath === path;
    const masterActive =
        isSelected('/categories') || isSelected('/technologies');
    // Collapse master when sidebar collapses
    // Collapse master when sidebar collapses
    React.useEffect(() => {
        if (!open) {
            setMasterOpen(false);
        } else {
            // reopen master only if route belongs to master
            if (location.pathname === '/categories' || location.pathname === '/technologies') {
                setMasterOpen(true);
            }
        }
    }, [open, location.pathname]);

    return (
        <Drawer
            variant="permanent"
            anchor="left"
            sx={{
                width: open ? DRAWER_WIDTH : COLLAPSED_WIDTH,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: open ? DRAWER_WIDTH : COLLAPSED_WIDTH,
                    boxSizing: 'border-box',
                    background: 'linear-gradient(180deg, #f7fbff 0%, #fffaf9 100%)',
                    borderRight: '1px solid rgba(16,24,40,0.04)',
                    mt: '64px',
                    px: 0.5,
                    overflowX: 'hidden',
                    zIndex: 'unset',
                },
            }}
        >
            <Box className={`sidebar-toggle-wrapper ${open ? 'open' : 'collapsed'}`}>
                <IconButton
                    size="small"
                    className="sidebar-toggle-btn"
                    onClick={() => {
                        if (onToggle) onToggle();
                        else onClose();
                    }}
                >
                    <img
                        src={open ? "/icons/MenuCollapseIcon.svg" : "/icons/MenuExpandicon.svg"}
                        alt="Toggle sidebar"
                        className="sidebar-toggle-icon"
                    />
                </IconButton>
            </Box>

            <List className={`sidebar-list ${open ? 'open' : 'collapsed'}`}>

                {/* Dashboard - ALL */}
                {/*<ListItem disablePadding className="sidebar-item-wrapper">*/}
                {/*    <ListItemButton*/}
                {/*        onClick={() => handleNavigate('/dashboard')}*/}
                {/*        className={`sidebar-item */}
                {/*                    ${open ? 'expanded' : 'collapsed'} */}
                {/*                    ${isSelected('/dashboard') ? 'active' : ''}*/}
                {/*        `}*/}
                {/*    >*/}
                {/*        <ListItemIcon className="sidebar-icon-column">*/}
                {/*            <Box*/}
                {/*                className={`sidebar-icon-box ${isSelected('/dashboard') ? 'active' : ''}`}*/}
                {/*            >*/}
                {/*                <LocalIcon*/}
                {/*                    src="/icons/Dashboard.svg"*/}
                {/*                    className="sidebar-local-icon"*/}
                {/*                />*/}
                {/*            </Box>*/}
                {/*        </ListItemIcon>*/}

                {/*        {open && <ListItemText primary="Dashboard"*/}
                {/*            className="sidebar-text"*/}
                {/*            secondary="Welcome!"*/}
                {/*        />}*/}
                {/*    </ListItemButton>*/}
                {/*</ListItem>*/}

                {/* MASTER - ADMIN ONLY */}
                {isAdmin && (
                    <>
                        {/* MASTER */}
                        <ListItem disablePadding className="sidebar-item-wrapper">
                            <ListItemButton
                                onClick={() => setMasterOpen(prev => !prev)}
                                className={`sidebar-item 
                                            ${open ? 'expanded' : 'collapsed'} 
                                            ${masterActive ? 'active' : ''}
                                `}
                            >
                                <ListItemIcon className="sidebar-icon-column">
                                    {open ? (
                                        <Box
                                            className={`sidebar-icon-box ${masterActive ? 'active' : ''}`}
                                        >
                                            <LocalIcon src="/icons/Master.svg" className="sidebar-local-icon" />
                                        </Box>
                                    ) : (
                                        <Tooltip title="Master" placement="right" arrow>
                                            <Box
                                                className={`sidebar-icon-box ${masterActive ? 'active' : ''}`}
                                            >
                                                <LocalIcon src="/icons/Master.svg" className="sidebar-local-icon" />
                                            </Box>
                                        </Tooltip>
                                    )}
                                </ListItemIcon>

                                {open && (
                                    <ListItemText
                                        className="sidebar-text"
                                        primary="Master"
                                        secondary="Manage Master Data"
                                    />
                                )}

                                {open && (masterOpen ? <ExpandLess /> : <ExpandMore />)}
                            </ListItemButton>
                        </ListItem>

                        {/* MASTER CHILDREN */}
                        {masterOpen && (
                            <Box className="sidebar-children">
                                {/* Categories */}
                                <ListItem disablePadding className="sidebar-item-wrapper">
                                    <ListItemButton
                                        onClick={() => handleNavigate('/categories')}
                                        className={`sidebar-item 
                                                 ${open ? 'expanded' : 'collapsed'} 
                                                 ${isSelected('/categories') ? 'active' : ''}
                                        `}
                                    >
                                        <ListItemIcon className="sidebar-icon-column">
                                            {open ? (
                                                <Box
                                                    className={`sidebar-icon-box ${isSelected('/categories') ? 'active' : ''}`}
                                                >
                                                    <LocalIcon src="/icons/Categories.svg" className="sidebar-local-icon" />
                                                </Box>
                                            ) : (
                                                <Tooltip title="Categories" placement="right" arrow>
                                                    <Box
                                                        className={`sidebar-icon-box ${isSelected('/categories') ? 'active' : ''}`}
                                                    >
                                                        <LocalIcon src="/icons/Categories.svg" className="sidebar-local-icon" />
                                                    </Box>
                                                </Tooltip>
                                            )}
                                        </ListItemIcon>

                                        {open && (
                                            <ListItemText
                                                className="sidebar-text"
                                                primary="Categories"
                                                secondary="create & manage Categories"                         
                                            />
                                        )}
                                    </ListItemButton>
                                </ListItem>

                                {/* Technologies */}
                                <ListItem disablePadding className="sidebar-item-wrapper">
                                    <ListItemButton
                                        onClick={() => handleNavigate('/technologies')}
                                        className={`sidebar-item 
                                                 ${open ? 'expanded' : 'collapsed'} 
                                                 ${isSelected('/technologies') ? 'active' : ''}
                                        `}
                                    >
                                        <ListItemIcon className="sidebar-icon-column">
                                            {open ? (
                                                <Box
                                                    className={`sidebar-icon-box ${isSelected('/technologies') ? 'active' : ''}`}
                                                >
                                                    <LocalIcon src="/icons/Technologies.svg" className="sidebar-local-icon" />
                                                </Box>
                                            ) : (
                                                <Tooltip title="Technologies" placement="right" arrow>
                                                    <Box
                                                        className={`sidebar-icon-box ${isSelected('/technologies') ? 'active' : ''}`}
                                                    >
                                                        <LocalIcon src="/icons/Technologies.svg" className="sidebar-local-icon" />
                                                    </Box>
                                                </Tooltip>
                                            )}
                                        </ListItemIcon>

                                        {open && (
                                            <ListItemText
                                                className="sidebar-text"
                                                primary="Technologies"
                                                secondary="View Technologies"
                                            />
                                        )}
                                    </ListItemButton>
                                </ListItem>
                            </Box>
                        )}
                    </>
                )}

                {/* ACTIVITIES - ADMIN + MANAGER */}
                {(isAdmin || isManager) && (
                    <ListItem disablePadding className="sidebar-item-wrapper">
                        <ListItemButton
                            onClick={() => handleNavigate('/activities')}
                            className={`sidebar-item 
                                                 ${open ? 'expanded' : 'collapsed'} 
                                                 ${isSelected('/activities') ? 'active' : ''}
                            `}
                        >
                            <ListItemIcon
                                className="sidebar-icon-column"
                            >
                                {open ? (
                                    <Box
                                        className={`sidebar-icon-box ${isSelected('/activities') ? 'active' : ''}`}
                                    >
                                        <LocalIcon src="/icons/Activities.svg"
                                            className="sidebar-local-icon"
                                        />
                                    </Box>
                                ) : (
                                    <Tooltip title="Activities" placement="right" arrow>
                                        <Box
                                            className={`sidebar-icon-box ${isSelected('/activities') ? 'active' : ''}`}
                                        >
                                            <LocalIcon src="/icons/Activities.svg"
                                                className="sidebar-local-icon"
                                            />
                                        </Box>
                                    </Tooltip>
                                )}
                            </ListItemIcon>

                            {open && (
                                <ListItemText
                                    className="sidebar-text"
                                    primary="Activities"
                                    secondary="Create & manage Activities"
                                />
                            )}
                        </ListItemButton>
                    </ListItem>
                )}

                {/* ASSIGN ACTIVITY - ADMIN + MANAGER */}
                {(isAdmin || isManager) && (
                    <ListItem disablePadding className="sidebar-item-wrapper">
                        <ListItemButton
                            onClick={() => handleNavigate('/assign-activity')}
                            className={`sidebar-item 
                                    ${open ? 'expanded' : 'collapsed'} 
                                    ${isSelected('/assign-activity') ? 'active' : ''}
                            `}
                        >
                            <ListItemIcon
                                className="sidebar-icon-column"
                            >
                                {open ? (
                                    <Box
                                        className={`sidebar-icon-box ${isSelected('/assign-activity') ? 'active' : ''}`}
                                    >
                                        <LocalIcon src="/icons/AssignActivity.svg"
                                            className="sidebar-local-icon"
                                        />
                                    </Box>
                                ) : (
                                    <Tooltip title="Assign Activity" placement="right" arrow>
                                        <Box
                                            className={`sidebar-icon-box ${isSelected('/assign-activity') ? 'active' : ''}`}
                                        >
                                            <LocalIcon src="/icons/AssignActivity.svg"
                                                className="sidebar-local-icon"
                                            />
                                        </Box>
                                    </Tooltip>
                                )}
                            </ListItemIcon>

                            {open && (
                                <ListItemText
                                    className="sidebar-text"
                                    primary="Assign Activity"
                                    secondary="Assign Activities"                                   
                                />
                            )}
                        </ListItemButton>
                    </ListItem>
                )}

                {/* MY ACTIVITY - ALL */}
                <ListItem disablePadding className="sidebar-item-wrapper">
                    <ListItemButton
                        onClick={() => handleNavigate('/my-activity')}
                        className={`sidebar-item 
                              ${open ? 'expanded' : 'collapsed'} 
                              ${isSelected('/my-activity') ? 'active' : ''}
                        `}
                    >
                        <ListItemIcon className="sidebar-icon-column">
                            {open ? (
                                <Box
                                    className={`sidebar-icon-box ${isSelected('/my-activity') ? 'active' : ''}`}
                                >
                                    <LocalIcon src="/icons/MyActivity.svg"
                                        className="sidebar-local-icon"
                                    />
                                </Box>
                            ) : (
                                <Tooltip title="My Activity" placement="right" arrow>
                                    <Box
                                        className={`sidebar-icon-box ${isSelected('/my-activity') ? 'active' : ''}`}
                                    >
                                        <LocalIcon src="/icons/MyActivity.svg"
                                            className="sidebar-local-icon"
                                        />
                                    </Box>
                                </Tooltip>
                            )}
                        </ListItemIcon>

                        {open && (
                            <ListItemText
                                className="sidebar-text"
                                primary="My Activity"
                                secondary="Track & Act on my Activities"
                            />
                        )}
                    </ListItemButton>
                </ListItem>

            </List>
        </Drawer>
    );
};

export default Sidebar;